import * as React from "react";
import SSLPitch from "./SSLPitch";

function HeroSocialIcon({ type }) {
  if (type === "x") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M13.5 22v-9h3l.45-3.5H13.5V7.26c0-1.01.28-1.7 1.74-1.7H17.1V2.43a25 25 0 0 0-2.7-.14c-2.67 0-4.5 1.63-4.5 4.63V9.5H7v3.5h2.9v9h3.6Z" />
    </svg>
  );
}

function TopLayout() {
  return (
    <header className="trps-hero" id="Top">
      <div className="trps-hero__bg" aria-hidden="true">
        <SSLPitch hud="off" loop={11000} />
      </div>
      <div className="trps-hero__veil" aria-hidden="true" />

      <div className="trps-hero__center">
        <h1 className="trps-hero__logo">
          <img src="/icon/TRAPS_logo_v_tight.svg" alt="TRAPS" />
        </h1>
        <p className="trps-hero__desc">
          RoboCup Soccer Team
        </p>
        <p className="trps-hero__tagline">
          2050年に向けた<span className="accent">次の一手</span>へ
        </p>
        <div className="trps-hero__social">
          <a href="https://twitter.com/TRAPS_RoboCup" target="_blank" rel="noopener noreferrer" aria-label="TRAPSのX">
            <HeroSocialIcon type="x" />
          </a>
          <a href="https://www.facebook.com/profile.php?id=61559205031125" target="_blank" rel="noopener noreferrer" aria-label="TRAPSのFacebook">
            <HeroSocialIcon type="facebook" />
          </a>
        </div>
      </div>

      <div className="trps-hero__scroll" aria-hidden="true">
        <span />
      </div>
    </header>
  );
}

export default TopLayout;
